/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : columns.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import CustomButtonV2 from "../../../../../components/customComponentsV2/common/button/CustomButtonV2";
import { componentStyle } from "../../../../../config/appTheme";
import CustomToolTip from "../../../../../components/infoButton/CustomToolTip";

export const availableColumns = (onAttach) => [
  {
    field: "standard_code",
    headerName: "Standard",
    width: 110,
    renderCell: (params) => (
      <CustomToolTip length={15} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.standard_code}
      </CustomToolTip>
    ),
  },
  {
    field: "name",
    headerName: "Name",
    width: 110,
    renderCell: (params) => (
      <CustomToolTip length={20} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.name}
      </CustomToolTip>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    width: 110,
    flex: 1,
    renderCell: (params) => (
      <CustomToolTip length={20} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.description}
      </CustomToolTip>
    ),
  },
  {
    field: "action",
    headerName: "Action",
    width: 120,
    renderCell: (params) => (
      <CustomButtonV2
        size="small"
        type="submit"
        btnName="Attach"
        handleOnClick={() => onAttach(params.row)}
      />
    ),
  },
];

export const attachedColumns = (onDetach) => [
  {
    field: "standard_code",
    headerName: "Standard",
    width: 110,
    renderCell: (params) => (
      <CustomToolTip length={15} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.standard_code}
      </CustomToolTip>
    ),
  },
  {
    field: "name",
    headerName: "Name",
    width: 110,
    renderCell: (params) => (
      <CustomToolTip length={20} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.name}
      </CustomToolTip>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    width: 110,
    flex: 1,
    renderCell: (params) => (
      <CustomToolTip length={20} style={{ ...componentStyle.font.tableText, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {params.row.description}
      </CustomToolTip>
    ),
  },
  {
    field: "action",
    headerName: "Actions",
    width: 120,
    renderCell: (params) => (
      <CustomButtonV2
        size="small"
        type="cancel"
        btnName="Detach"
        handleOnClick={() => onDetach(params.row)}
      />
    ),
  },
];
